"use client"

import {
	anonymousClient,
	emailOTPClient,
	genericOAuthClient,
	phoneNumberClient,
} from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"
import { mapWebLangToServerLang } from "../i18n/utils"
import {
	getCurrentAreaInClient,
	getCurrentLanguageInClient,
} from "../utils.client"

// 创建认证客户端
export const authClient = createAuthClient({
	// 如果 API 服务器与前端不在同一域名下，需要指定 baseURL
	baseURL: (() => {
		const serverUrl = process.env.NEXT_PUBLIC_SERVER_URL
		if (!serverUrl) {
			console.warn(
				"[Auth Client] NEXT_PUBLIC_SERVER_URL is not set, using fallback",
			)
			// 如果没有设置服务器URL，使用相对路径作为fallback
			return "/api/auth"
		}
		return `${serverUrl}/api/auth`
	})(),

	// 使用 Better Auth 的 fetchOptions 来动态配置请求
	fetchOptions: {
		// 确保认证请求包含cookies
		credentials: "include",

		// 动态获取headers
		headers: {
			// 动态获取区域信息
			get "X-AREA"() {
				return getCurrentAreaInClient()
			},
			get "Accept-Language"() {
				return mapWebLangToServerLang(getCurrentLanguageInClient())
			},

			// 同盾头部已改为动态处理，在调用时通过 fetchOptions.headers 传入
		},
	},

	plugins: [
		emailOTPClient(),
		phoneNumberClient(),
		genericOAuthClient(),
		anonymousClient(),
	],
})
